import { createContent } from "@altify/utils";

export const portfolioContent = createContent({
    en: {
        inUse: 'In Use',
        cashBalance: 'Cash Balance',
        portfolioValue: 'Portfolio Value',
        return: '24h Return',
        deposit: 'Deposit',
        withdraw: 'Withdraw',
        infoTitle: "Gain/Loss Calculation",
        infoText: "Total Portfolio Gain/Loss = Closing Portfolio Value + Withdrawals - Deposits - Opening Portfolio Value",
        inUseInfoTitle: "In Use",
        inUseInfoText: "Withdrawals being processed. ",
        cashBalanceInfoTitle: "Cash Balance",
        cashBalanceInfoText: "Local currency and stablecoin balances available to invest or withdraw.",
    },
    de: {
        inUse: 'In Use',
        cashBalance: 'Cash Balance',
        portfolioValue: 'Portfolio Value',
        return: 'Return',
        deposit: 'Deposit',
        withdraw: 'Withdraw',
        infoTitle: "Gewinn/Verlust Berechnung",
        infoText: "Gesamter Portfolio Gewinn/Verlust = Endportfoliowert + Auszahlungen - Einzahlungen - Startportfoliowert",
        inUseInfoTitle: "In Use",
        inUseInfoText: "Withdrawals being processed. ",
        cashBalanceInfoTitle: "Cash Balance",
        cashBalanceInfoText: "Local currency and stablecoin balances available to invest or withdraw.",
    },
})